// If you are adding a term to the ActionSubjectId glossary,
// please add a member of the Data team to your PR

// For help naming UI components, see:
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329336/UI+Events

// For help naming track event entities, see:
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329319/Track+Events

// Screens that are e.g. closed or dismissed via sendClosedComponentEvent or sendDismissedComponentEvent
const inlineDialogs = {
  boardMenuDrawerEnterpriseUpsellInlineDialog:
    'boardMenuDrawerEnterpriseUpsellInlineDialog',
  boardsMenuInlineDialog: 'boardsMenuInlineDialog',
  boardPowerUpOnboardingInlineDialog: 'boardPowerUpOnboardingInlineDialog',
  createBoardBackgroundChooserInlineDialog:
    'createBoardBackgroundChooserInlineDialog',
  createFromTemplateInlineDialog: 'createFromTemplateInlineDialog',
  inlineDialogBackButton: 'inlineDialogBackButton',
  pupLimitBCUpsellInlineDialog: 'pupLimitBCUpsellInlineDialog',
  reactionSelectorInlineDialog: 'reactionSelectorInlineDialog',
  searchInlineDialog: 'searchInlineDialog',
  tacoTemplateTipsInlineDialog: 'tacoTemplateTipsInlineDialog',
  teamTemplatePickerInlineDialog: 'teamTemplatePickerInlineDialog',
  useTemplateInlineDialog: 'useTemplateInlineDialog',
} as const;

const modals = {
  freeTrialModal: 'freeTrialModal',
  cancelBusinessClassModal: 'cancelBusinessClassModal',
} as const;

// Sections on a page, e.g. in the home feed, card back, settings page
// web/guide/concepts/analytics.md for further guidance
const sections = {
  teamTemplatePickerSection: 'teamTemplatePickerSection',
  teamGettingStartedHomeSectionItem: 'teamGettingStartedHomeSectionItem',
  yourItemsSection: 'yourItemsSection',
  pupAttachmentSuggestionSection: 'pupAttachmentSuggestionSection',
} as const;

// Items within the sections
const sectionItems = {
  atlassianAccountSectionMessage: 'atlassianAccountSectionMessage',
  teamGettingStartedAddBoardLink: 'teamGettingStartedAddBoardLink',
  teamGettingStartedPermissionsLink: 'teamGettingStartedPermissionsLink',
  teamGettingStartedPowerupLink: 'teamGettingStartedPowerupLink',
  teamGettingStartedSettingsLink: 'teamGettingStartedSettingsLink',
  templateTileSectionItem: 'templateTileSectionItem',
} as const;

// Banners are commonly displayed between the app header and the board header
const banners = {
  atlassianAccessAdBanner: 'atlassianAccessAdBanner',
  atlassianAccountAutomaticOnboardingBanner:
    'atlassianAccountAutomaticOnboardingBanner',
  atlassianAccountMigrationBanner: 'atlassianAccountMigrationBanner',
  atlassianAccountOnboardingBanner: 'atlassianAccountOnboardingBanner',
  atlassianManagedAccountBanner: 'atlassianManagedAccountBanner',
  boardLimitsDowngradeBanner: 'boardLimitsDowngradeBanner',
  browserWillBeUnsupportedBanner: 'browserWillBeUnsupportedBanner',
  emailHygieneBanner: 'emailHygieneBanner',
  emailVerificationBanner: 'emailVerificationBanner',
  enterpriseDeprovisioningBanner: 'enterpriseDeprovisioningBanner',
  enterpriseLicenseBanner: 'enterpriseLicenseBanner',
  freeTeamLimitWarningBanner: 'freeTeamLimitWarningBanner',
  freeTeamLimitRestrictedBanner: 'freeTeamLimitRestrictedBanner',
  freeTrialBanner: 'freeTrialBanner',
  invitedBanner: 'invitedBanner',
  loggedInPublicBoardBanner: 'loggedInPublicBoardBanner',
  newLocaleBanner: 'newLocaleBanner',
  overdueBanner: 'overdueBanner',
  personalBoardsOwnershipBanner: 'personalBoardsOwnershipBanner',
  setPasswordBanner: 'setPasswordBanner',
  upgradePromptBanner: 'upgradePromptBanner',
} as const;

// UI elements
const buttons = {
  accountSwitcherLoginAndUpdateButton: 'accountSwitcherLoginAndUpdateButton',
  actionableTaskButton: 'actionableTaskButton',
  addAnotherCardButton: 'addAnotherCardButton',
  addAnotherListButton: 'addAnotherListButton',
  addAppsButton: 'addAppsButton',
  addCardFromMapButton: 'addCardFromMapButton',
  addIntegrationsButton: 'addIntegrationsButton',
  addMoreBoardsButton: 'addMoreBoardsButton',
  addPaymentButton: 'addPaymentButton',
  addPowerUpsButton: 'addPowerUpsButton',
  addTeamFromCollectionsButton: 'addTeamFromCollectionsButton',
  addToEnterpriseButton: 'addToEnterpriseButton',
  annualBillingButton: 'annualBillingButton',
  allBoardMembersButton: 'allBoardMembersButton',
  applyDiscountButton: 'applyDiscountButton',
  atlassianAccountCompleteOnboardingSuccessButton:
    'atlassianAccountCompleteOnboardingSuccessButton',
  atlassianAccountOnboardingBannerSnoozeButton:
    'atlassianAccountOnboardingBannerSnoozeButton',
  atlassianAccountOnboardingContinueButton:
    'atlassianAccountOnboardingContinueButton',
  atlassianAccountOnboardingForWorkButton:
    'atlassianAccountOnboardingForWorkButton',
  atlassianAccountOnboardingNotWorkButton:
    'atlassianAccountOnboardingNotWorkButton',
  atlassianAccountOnboardingOverlayCloseButton:
    'atlassianAccountOnboardingOverlayCloseButton',
  atlassianAccountOnboardingSuccessOverlay:
    'atlassianAccountOnboardingSuccessOverlay',
  atlassianAccountOnboardingUrgentContinueButton:
    'atlassianAccountOnboardingUrgentContinueButton',
  atlassianAccountOnboardingUrgentUpdate:
    'atlassianAccountOnboardingUrgentUpdate',
  atlassianAccountOnboardingWarningOverlay:
    'atlassianAccountOnboardingWarningOverlay',
  atlassianAutomaticOnboardingUpdateAccountButton:
    'atlassianAutomaticOnboardingUpdateAccountButton',
  atlassianAutomaticOnboardingCompleteButton:
    'atlassianAutomaticOnboardingCompleteButton',
  atlassianAutomaticAccountOnboardingOverlayCloseButton:
    'atlassianAutomaticAccountOnboardingOverlayCloseButton',
  atlassianAutomaticOnboardingContinueToAtlassianButton:
    'atlassianAutomaticOnboardingContinueToAtlassianButton',
  atlassianAutomaticOnboardingMismatchLoginButton:
    'atlassianAutomaticOnboardingMismatchLoginButton',
  atlassianAutomaticOnboardingConfirmationButton:
    'atlassianAutomaticOnboardingConfirmationButton',
  atlassianOnboardingGotItButton: 'atlassianOnboardingGotItButton',
  atlassianOnboardingGoToSettingsToRemoveEmailButton:
    'atlassianOnboardingGoToSettingsToRemoveEmailButton',
  atlassianOnboardingHelpDocButton: 'atlassianOnboardingHelpDocButton',
  atlassianOnboardingLoginWithAtlassianButton:
    'atlassianOnboardingLoginWithAtlassianButton',
  atlassianOnboardingMenuBackButton: 'atlassianOnboardingMenuBackButton',
  atlassianOnboardingMixedUseAccountButton:
    'atlassianOnboardingMixedUseAccountButton',
  atlassianOnboardingPersonalAccountButton:
    'atlassianOnboardingPersonalAccountButton',
  atlassianOnboardingRemoveEmailButton: 'atlassianOnboardingRemoveEmailButton',
  atlassianSwitcherHeaderButton: 'atlassianSwitcherHeaderButton',
  atlassianManagedAccountLearnMoreButton:
    'atlassianManagedAccountBannerLearnMoreButton',
  atlassianManagedAccountOverlayCloseButton:
    'atlassianManagedAccountOverlayCloseButton',
  atlassianManagedAccountOverlayGotItButton:
    'atlassianManagedAccountOverlayGotItButton',
  attachmentGetPowerEnableButton: 'attachmentGetPowerEnableButton',
  autoEnableCalendarDisableButton: 'autoEnableCalendarDisableButton',
  autoEnableCalendarOpenDirectoryButton:
    'autoEnableCalendarOpenDirectoryButton',
  autoEnableCalendarPrimaryButton: 'autoEnableCalendarPrimaryButton',
  avatarGravatarOptionButton: 'avatarGravatarOptionButton',
  avatarNoneOptionButton: 'avatarNoneOptionButton',
  avatarPreviouslyUploadedOptionButton: 'avatarPreviouslyUploadedOptionButton',
  backButton: 'backButton',
  bcUpgradeFromTemplatesPowerUpButton: 'bcUpgradeFromTemplatesPowerUpButton',
  boardButton: 'boardButton', // for power-up board buttons
  boardDirectoryCloseButton: 'boardDirectoryCloseButton',
  boardMenuDrawerCloseButton: 'boardMenuDrawerCloseButton',
  boardOrganizationButton: 'boardOrganizationButton',
  boardsMenuButton: 'boardsMenuButton',
  boardViewsButton: 'boardViewsButton',
  browseButton: 'browseButton',
  calendarPowerUpBoardButton: 'calendarPowerUpBoardButton',
  cancelBusinessClassButton: 'cancelBusinessClassButton',
  closeCancelBusinessClassModalButton: 'closeCancelBusinessClassModalButton',
  cancelButton: 'cancelButton',
  cancelEditDescriptionButton: 'cancelEditDescriptionButton',
  cancelTrelloGoldButton: 'cancelTrelloGoldButton',
  cardButton: 'cardButton',
  cardComposerMenuButton: 'cardComposerMenuButton',
  cardCoverAttachmentShowFewerButton: 'cardCoverAttachmentShowFewerButton',
  cardCoverAttachmentShowMoreButton: 'cardCoverAttachmentShowMoreButton',
  cardCoverAttachmentUploadButton: 'cardCoverAttachmentUploadButton',
  cardCoverUnsplashSearchButton: 'cardCoverUnsplashSearchButton',
  cardCoverUnsplashSuggestionButton: 'cardCoverUnsplashSuggestionButton',
  cardMapEditLocationButton: 'cardMapEditLocationButton',
  cardMapLocationButton: 'cardMapLocationButton',
  cardNameButton: 'cardNameButton',
  changeBoardOrganizationButton: 'changeBoardOrganizationButton',
  changeBoardVisibilityButton: 'changeBoardVisibilityButton',
  changeCreditCardButton: 'changeCreditCardButton',
  changeCreditCardForm: 'changeCreditCardForm',
  changeEmailButton: 'changeEmailButton',
  changeListButton: 'changeListButton',
  chargeMonthlyButon: 'chargeMonthlyButton',
  chargeYearlyButon: 'chargeYearlyButton',
  checkItemMenuButton: 'checkItemMenuButton',
  clearBoardFilterButton: 'clearBoardFilterButton',
  closedBoardsButton: 'closedBoardsButton',
  configureTwoFactorAuthButton: 'configureTwoFactorAuthButton',
  convertCheckItemToCardButton: 'convertCheckItemToCardButton',
  convertToTemplateButton: 'convertToTemplateButton',
  copyBoardButton: 'copyBoardButton',
  copyLinkButton: 'copyLinkButton',
  createBoardButton: 'createBoardButton',
  createBoardFromTemplateButton: 'createBoardFromTemplateButton',
  createCardButton: 'createCardButton',
  createCardFromTemplateButton: 'createCardFromTemplateButton',
  createMenuHeaderButton: 'createMenuHeaderButton',
  createNewAccountButton: 'createNewAccountButton',
  createTemplateKeyboardSubmit: 'createTemplateKeyboardSubmit',
  deleteCheckItemButton: 'deleteCheckItemButton',
  dismissButton: 'dismissButton',
  downgradeToFreeButton: 'downgradeToFreeButton',
  dueCellButton: 'dueCellButton',
  editDescriptionButton: 'editDescriptionButton',
  emailButton: 'emailButton', // social share button
  emptyPowerUpSlotButton: 'emptyPowerUpSlotButton',
  enterpriseButton: 'enterpriseButton',
  exploreTemplatesButton: 'exploreTemplatesButton',
  exportButton: 'exportButton',
  boardFilterButton: 'boardFilterButton',
  facebookButton: 'facebookButton',
  filterTableByDueDateButton: 'filterTableByDueDateButton',
  filterTableByLabelButton: 'filterTableByLabelButton',
  filterTableByListButton: 'filterTableByListButton',
  filterTableByMemberButton: 'filterTableByMemberButton',
  formattingHelpDescriptionButton: 'formattingHelpDescriptionButton',
  getStartedButton: 'getStartedButton',
  getStartedTypeformButton: 'getStartedTypeformButton',
  inviteTeamMembersButton: 'inviteTeamMembersButton',
  inviteToBoardButton: 'inviteToBoardButton',
  inviteToBoardLinkCopyButton: 'inviteToBoardLinkCopyButton',
  joinBoardButton: 'joinBoardButton',
  keepPhotoButton: 'keepPhotoButton',
  keepBusinessClassButton: 'keepBusinessClassButton',
  learnMoreButton: 'learnMoreButton',
  linkCopyButton: 'linkCopyButton',
  linkedinButton: 'linkedinButton',
  listMenuButton: 'listMenuButton',
  marketingOptInButton: 'marketingOptInButton',
  marketingOptOutButton: 'marketingOptOutButton',
  memberListButton: 'memberListButton',
  monthlyBillingButton: 'monthlyBillingButton',
  powerUpAddButton: 'powerUpAddButton',
  powerUpBoardButton: 'powerUpBoardButton',
  powerUpCardButton: 'powerUpCardButton',
  powerUpEditButton: 'powerUpEditButton',
  powerUpSlotButton: 'powerUpSlotButton',
  purchaseBusinessClassButton: 'purchaseBusinessClassButton',
  purchaseGoldButton: 'purchaseGoldButton',
  removeDateButton: 'removeDateButton',
  removeEmailButton: 'removeEmailButton',
  renewBusinessClassButton: 'renewBusinessClassButton',
  renewTrelloGoldButton: 'renewTrelloGoldButton',
  restoreBCButton: 'restoreBCButton',
  setAsPrimaryEmailButton: 'setAsPrimaryEmailButton',
  setUpAtlassianAccountAndRemoveEmailsButton:
    'setUpAtlassianAccountAndRemoveEmailsButton',
  shareButton: 'shareButton',
  showAllActivityButton: 'showAllActivityButton',
  showAllPowerUpsButton: 'showAllPowerUpsButton',
  showCommentsOnlyButton: 'showCommentsOnlyButton',
  showFewerPowerUpsButton: 'showFewerPowerUpsButton',
  showFullDescriptionButton: 'showFullDescriptionButton',
  showMoreYourItemsButton: 'showMoreYourItemsButton',
  signUpButton: 'signUpButton',
  startFreeTrialButton: 'startFreeTrialButton',
  tacoTemplateTipsButton: 'tacoTemplateTipsButton',
  teamGettingStartedCompleteHideButton: 'teamGettingStartedCompleteHideButton',
  teamGettingStartedInviteButton: 'teamGettingStartedInviteButton',
  teamGettingStartedMenuButton: 'teamGettingStartedMenuButton',
  teamGettingStartedMenuHideButton: 'teamGettingStartedMenuHideButton',
  teamGettingStartedPupsAddPowerupButton:
    'teamGettingStartedPupsAddPowerupButton',
  teamGettingStartedPupsDismissButton: 'teamGettingStartedPupsDismissButton',
  teamTabCollapseButton: 'teamTabCollapseButton',
  teamTabExpandButton: 'teamTabExpandButton',
  tryBackgroundButton: 'tryBackgroundButton',
  twitterButton: 'twitterButton',
  removeCardCoverButton: 'removeCardCoverButton',
  upgradeButton: 'upgradeButton',
  upgradeToBCButton: 'upgradeToBCButton',
  useTemplateButton: 'useTemplateButton',
  viewTemplateButton: 'viewTemplateButton',
  copyTemplateButton: 'copyTemplateButton',
  dismissTemplateButton: 'dismissTemplateButton',
  changeOrgProfileButton: 'changeOrgProfileButton',
  unfurlActionButton: 'unfurlActionButton',
  saveAttachmentButton: 'saveAttachmentButton',
  saveDateButton: 'saveDateButton',
  startWithBlankBoardTileButton: 'startWithBlankBoardTileButton',
  workspacesPreambleBoardInviteButton: 'workspacesPreambleBoardInviteButton',
  workspacesPreambleAddToTeamButton: 'workspacesPreambleAddToTeamButton',
  workspacesPreambleUpgradeButton: 'workspacesPreambleUpgradeButton',
} as const;

const links = {
  advancedChecklistLearnMoreLink: 'advancedChecklistLearnMoreLink',
  aboutThisTemplateLink: 'aboutThisTemplateLink',
  accountSwitcherUpdateLink: 'accountSwitcherUpdateLink',
  alwaysKeepMenuOpenLink: 'alwaysKeepMenuOpenLink',
  atlassian2FALearnMoreLink: 'atlassian2FALearnMoreLink',
  atlassianAccessSeeDetailsLink: 'atlassianAccessSeeDetailsLink',
  atlassianAutoOnboardingHelpLink: 'atlassianAutoOnboardingHelpLink',
  atlassianManagedAccountHelpLink: 'atlassianManagedAccountHelpLink',
  attachmentGetPowerLearnMoreLink: 'attachmentGetPowerLearnMoreLink',
  backgroundOptionsLink: 'backgroundOptionsLink',
  bcUpgradeFromTemplatesPowerUpDescriptionLink:
    'bcUpgradeFromTemplatesPowerUpDescriptionLink',
  bcUpgradeFromTemplatesStoryHeaderLink:
    'bcUpgradeFromTemplatesStoryHeaderLink',
  boardMenuPowerUpLink: 'boardMenuPowerUpLink',
  boardMenuDrawerToggleLink: 'boardMenuDrawerToggleLink', // 'Show Menu' link in board header
  boardNameLink: 'boardNameLink',
  boardSearchResultLink: 'boardSearchResultLink',
  businessClassLink: 'businessClassLink',
  cardNameLink: 'cardNameLink',
  cardMapExternalLink: 'cardMapExternalLink',
  cardSearchResultLink: 'cardSearchResultLink',
  categoryNavLink: 'categoryNavLink',
  changeBoardOrganizationLink: 'changeBoardOrganizationLink',
  changePasswordLink: 'changePasswordLink',
  checkInboxLink: 'checkInboxLink',
  checkItemNameLink: 'checkItemNameLink',
  convertToTemplateLink: 'convertToTemplateLink',
  createBoardLink: 'createBoardLink',
  createCollectionLink: 'createCollectionLink',
  createNewOrgLink: 'createNewOrgLink',
  customBoardBackgroundLink: 'customBoardBackgroundLink',
  customPowerUpLearnMoreHeaderLink: 'customPowerUpLearnMoreHeaderLink',
  downloadLink: 'downloadLink',
  enterpriseLink: 'enterpriseLink',
  fullNameProfileLink: 'fullNameProfileLink',
  giveFeedbackLink: 'giveFeedbackLink',
  goldLink: 'goldLink',
  integrationsNavigationMenuLink: 'integrationsNavigationMenuLink',
  inviteTeamMemberLink: 'inviteTeamMemberLink',
  inviteToBoardCreateLink: 'inviteToBoardCreateLink',
  inviteToBoardDisableLink: 'inviteToBoardDisableLink',
  inviteToBoardLink: 'inviteToBoardLink',
  learnMoreLink: 'learnMoreLink',
  mapLocationPowerUpLink: 'mapLocationPowerUpLink',
  memberSearchResultLink: 'memberSearchResultLink',
  moonshotExploreLink: 'moonshotExploreLink',
  resendEmailLink: 'resendEmailLink',
  seeClosedBoardsLink: 'seeClosedBoardsLink',
  settingsSwitchAccountsLink: 'settingsSwitchAccountsLink',
  shareTemplateLink: 'shareTemplateLink',
  showLessActiveBoardsLink: 'showLessActiveBoardsLink',
  showMoreCardsLink: 'showMoreCardsLink',
  showSearchTipsLink: 'showSearchTipsLink',
  startWithTemplateLink: 'startWithTemplateLink',
  submitTemplateLink: 'submitTemplateLink',
  teamBoardTableViewLink: 'teamBoardTableViewLink',
  teamBillingPageLink: 'teamBillingPageLink',
  teamGettingStartedPupsViewMoreLink: 'teamGettingStartedPupsViewMoreLink',
  teamPageLink: 'teamPageLink',
  teamSearchResultLink: 'teamSearchResultLink',
  teamTableLink: 'teamTableLink',
  templateExternalLink: 'templateExternalLink',
  templatesHelpLink: 'templatesHelpLink',
  templateLink: 'templateLink',
  templateNameLink: 'templateNameLink',
  templateThumbnailLink: 'templateThumbnailLink',
  twoFactorAuthBackupCodesLink: 'twoFactorAuthBackupCodesLink',
  updateAccountLink: 'updateAccountLink',
  updateBillingInfoLink: 'updateBillingInfoLink',
  updateProfileLink: 'updateProfileLink',
  upgradeBrowserLink: 'upgradeBrowserLink',
  viewsFeedbackLink: 'viewsFeedbackLink',
  approachingBoardLimitUpgradeTemplateLink:
    'approachingBoardLimitUpgradeTemplateLink',
  atBoardLimitUpgradeTemplateLink: 'atBoardLimitUpgradeTemplateLink',
  upgradeToBCLink: 'upgradeToBCLink',
  viewOrganizationLink: 'viewOrganizationLink',
  yourItemsLink: 'yourItemsLink',
} as const;

const inputFields = {
  boardNameInput: 'boardNameInput',
  linkCopyInput: 'linkCopyInput',
  searchInput: 'searchInput',
  fileInputUpload: 'fileInputUpload',
  cardCoverUnsplashSearchInput: 'cardCoverUnsplashSearchInput',
} as const;

const pills = {
  bcUpgradePill: 'bcUpgradePill',
} as const;

// For links in the board menu drawer
const drawerNavigationItems = {
  cardCoversDrawerNavigationItem: 'cardCoversDrawerNavigationItem',
  changeOrgDrawerNavigationItem: 'changeOrgDrawerNavigationItem',
  closeBoardDrawerNavigationItem: 'closeBoardDrawerNavigationItem',
  convertToBoardDrawerNavigationItem: 'convertToBoardDrawerNavigationItem',
  commentPermsDrawerNavigationItem: 'commentPermsDrawerNavigationItem',
  cookieConsentDrawerNavigationItem: 'cookieConsentDrawerNavigationItem',
  copyBoardDrawerNavigationItem: 'copyBoardDrawerNavigationItem',
  invitationsPermsDrawerNavigationItem: 'invitationsPermsDrawerNavigationItem',
  leaveDrawerNavigationItem: 'leaveDrawerNavigationItem',
  makeTemplateFromBoardDrawerNavigationItem:
    'makeTemplateFromBoardDrawerNavigationItem',
  powerUpDirectoryDrawerNavigationItem: 'powerUpDirectoryDrawerNavigationItem',
  removeOrgDrawerNavigationItem: 'removeOrgDrawerNavigationItem',
  selfJoinDrawerNavigationItem: 'selfJoinDrawerNavigationItem',
  votingPermsDrawerNavigationItem: 'votingPermsDrawerNavigationItem',
  watchDrawerNavigationItem: 'watchDrawerNavigationItem',
} as const;

// For info boxes, callouts within a component
const overlays = {
  atlassianAccountOnboardingAccountUpdateOverlay:
    'atlassianAccountOnboardingAccountUpdateOverlay',
  atlassianAccountOnboardingAutomaticMigrationOverlay:
    'atlassianAccountOnboardingAutomaticMigrationOverlay',
  atlassianAccountOnboardingAtlassianMigrationConfirmationOverlay:
    'atlassianAccountOnboardingAtlassianMigrationConfirmationOverlay',
  atlassianAccountOnboardingAtlassianProfileOverlay:
    'atlassianAccountOnboardingAtlassianProfileOverlay',
  atlassianManagedAccountOverlay: 'atlassianManagedAccountOverlay',
  collectionsExplainerOverlay: 'collectionsExplainerOverlay',
} as const;

// For options within a dropdown component
const dropdownItems = {
  boardViewDropdownItem: 'boardViewDropdownItem',
  calendarViewDropdownItem: 'calendarViewDropdownItem',
  inviteTeamToBoardDropdownItem: 'inviteTeamToBoardDropdownItem',
  mapViewDropdownItem: 'mapViewDropdownItem',
  templatePickerCategoryDropdownItem: 'templatePickerCategoryDropdownItem',
  timelineViewDropdownItem: 'timelineViewDropdownItem',
} as const;

const shortcuts = {
  boardsMenuShortcut: 'boardsMenuShortcut',
  clearAllFiltersShortcut: 'clearAllFiltersShortcut',
  escapeShortcut: 'escapeShortcut',
  insertCardShortcut: 'insertCardShortcut',
  moveDownShortcut: 'moveDownShortcut',
  moveLeftShortcut: 'moveLeftShortcut',
  moveRightShortcut: 'moveRightShortcut',
  moveUpShortcut: 'moveUpShortcut',
  myCardsShortcut: 'myCardsShortcut',
  redoActionShortcut: 'redoActionShortcut',
  repeatActionShortcut: 'repeatActionShortcut',
  searchAndFilterCardsShortcut: 'searchAndFilterCardsShortcut',
  searchShortcut: 'searchShortcut',
  toggleBoardMenuDrawerShortcut: 'toggleBoardMenuDrawerShortcut',
  toggleLabelTextShortcut: 'toggleLabelTextShortcut',
  undoActionShortcut: 'undoActionShortcut',
} as const;

const menuItems = {
  addCardMenuItem: 'addCardMenuItem',
  archiveAllCardsMenuItem: 'archiveAllCardsMenuItem',
  copyListMenuItem: 'copyListMenuItem',
  createBoardMenuItem: 'createBoardMenuItem',
  createFromTemplateMenuItem: 'createFromTemplateMenuItem',
  moveAllCardsMenuItem: 'moveAllCardsMenuItem',
  moveListMenuItem: 'moveListMenuItem',
  sortListMenuItem: 'sortListMenuItem',
  startWithTemplateMenuItem: 'startWithTemplateMenuItem',
} as const;

const icons = {
  infoIcon: 'infoIcon',
  reactionMenuIcon: 'reactionMenuIcon',
} as const;

const tabs = {
  boardsTab: 'boardsTab', // To track tab click that loads the memberBoardsHomeScreen
  homeTab: 'homeTab', // To track tab click that loads the memberHomeScreen
  templateGalleryTab: 'templateGalleryTab',
} as const;

// Team-specific terms
const atlassianAccountMigrationTerms = {
  atlassianAccountMigrationBannerLink: 'atlassianAccountMigrationBannerLink',
  atlassianAccountMigrationBannerDismissLink:
    'atlassianAccountMigrationBannerDismissLink',
  atlassianAccountMigrationRetryButton: 'atlassianAccountMigrationRetryButton',
  atlassianAccountMigrationChangeEmailButton:
    'atlassianAccountMigrationChangeEmailButton',
  atlassianAccountMigrationOverlay: 'atlassianAccountMigrationOverlay',
} as const;

const emailHygieneTerms = {
  emailHygieneBannerLink: 'emailHygieneBannerLink',
  emailHygieneBannerDismissLink: 'emailHygieneBannerDismissLink',
  emailHygieneWizard: 'emailHygieneWizard',
  emailHygieneWizardChangeEmailButton: 'emailHygieneWizardChangeEmailButton',
  emailHygieneWizardConfirmEmailButton: 'emailHygieneWizardConfirmEmailButton',
  emailHygieneWizardDismissLink: 'emailHygieneWizardDismissLink',
  emailHygieneWizardEmailItem: 'emailHygieneWizardEmailItem',
  emailHygieneWizardRemoveSecondaryEmailsButton:
    'emailHygieneWizardRemoveSecondaryEmailsButton',
  emailHygieneWizardScreenChooseEmail: 'emailHygieneWizardScreenChooseEmail',
  emailHygieneWizardScreenClaimableInfo:
    'emailHygieneWizardScreenClaimableInfo',
  emailHygieneWizardScreenConfirmationEmailSent:
    'emailHygieneWizardScreenConfirmationEmailSent',
  emailHygieneWizardScreenConfirmSingleEmail:
    'emailHygieneWizardScreenConfirmSingleEmail',
  emailHygieneWizardScreenError: 'emailHygieneWizardScreenError',
  emailHygieneWizardScreenSuccess: 'emailHygieneWizardScreenSuccess',
  emailHygieneTransferBoardsFooterLink: 'emailHygieneTransferBoardsFooterLink',
} as const;

export const jswCrossflowItems = {
  jswLearnMoreInlineDialog: 'jswLearnMoreInlineDialog',
  jswLearnMoreButton: 'jswLearnMoreButton',
  jswLearnMoreBanner: 'jswLearnMoreBanner',
  confluenceLearnMoreBanner: 'confluenceLearnMoreBanner',
  confluenceLearnMoreButton: 'confluenceLearnMoreButton',
} as const;

const tiles = {
  boardSelectorTile: 'boardSelectorTile',
  cardCoverAttachmentTile: 'cardCoverAttachmentTile',
  cardCoverColorTile: 'cardCoverColorTile',
  cardCoverSizeTile: 'cardCoverSizeTile',
  cardCoverTextColorTile: 'cardCoverTextColorTile',
  cardCoverUnsplashTile: 'cardCoverUnsplashTile',
  createBoardTile: 'createBoardTile',
  templateTile: 'templateTile',
} as const;

const actions = {
  joinCardAction: 'joinCardAction',
  leaveCardAction: 'leaveCardAction',
  addMemberToCardAction: 'addMemberToCardAction',
  removeMemberFromCardAction: 'removeMemberFromCardAction',
  moveCardAction: 'moveCardAction',
  addLabelToCardAction: 'addLabelToCardAction',
  removeLabelFromCardAction: 'removeLabelFromCardAction',
  archiveCardAction: 'archiveCardAction',
  unarchiveCardAction: 'unarchiveCardAction',
  renameCardAction: 'renameCardAction',
  updateCardDescriptionAction: 'updateCardDescriptionAction',
};

const otherActionSubjectIds = {
  atlassianAccountOnboardingOverlay: 'atlassianAccountOnboardingOverlay',
  assignedCheckItem: 'assignedCheckItem',
  bcFreeTrial: 'bcFreeTrial',
  bcFreeTrialUpsell: 'bcFreeTrialUpsell',
  bcPayment: 'bcPayment',
  bcTeam: 'bcTeam',
  bcUpgradePrompt: 'bcUpgradePrompt',
  bcUpgradeSurvey: 'bcUpgradeSurvey',
  boardDescription: 'boardDescription',
  boardInvitation: 'boardInvitation', // Adding members to board
  boardSelectorTile: 'boardSelectorTile',
  businessClassUpgrade: 'businessClassUpgrade',
  cardComposerList: 'cardComposerList',
  cardComposerPosition: 'cardComposerPosition',
  cardDescription: 'cardDescription',
  cardDetailBadge: 'cardDetailBadge',
  cardMapLocation: 'cardMapLocation',
  cardMember: 'cardMember',
  closedBoardsModal: 'closedBoardsModal',
  colorBlindFriendlyMode: 'colorBlindFriendlyMode',
  colorBoardBackground: 'colorBoardBackground',
  customBoardBackground: 'customBoardBackground',
  descriptionEdit: 'descriptionEdit',
  dismissPluginSuggestionButton: 'dismissPluginSuggestionButton',
  dueDateBadge: 'dueDateBadge',
  editSettingsOption: 'editSettingsOption',
  filterTableByLabel: 'filterTableByLabel',
  filterTableByList: 'filterTableByList',
  filterTableByMember: 'filterTableByMember',
  filterTableDueComplete: 'filterTableDueComplete',
  filterTableDueIncomplete: 'filterTableDueIncomplete',
  filterTableDueNextDay: 'filterTableDueNextDay',
  filterTableDueNextMonth: 'filterTableDueNextMonth',
  filterTableDueNextWeek: 'filterTableDueNextWeek',
  filterTableNoDueDate: 'filterTableNoDueDate',
  filterTableOverdue: 'filterTableOverdue',
  freeTeam: 'freeTeam',
  fullUpgradePrompt: 'fullUpgradePrompt',
  learnMoreAboutBCButton: 'learnMoreAboutBCButton',
  leaveBoardMenu: 'leaveBoardMenu',
  listLimit: 'listLimit',
  mapMarker: 'mapMarker',
  marketingEmail: 'marketingEmail',
  moonshotStep: 'moonshotStep',
  miniProfileAvatar: 'miniProfileAvatar',
  objectResolverClient: 'objectResolverClient',
  photoBoardBackground: 'photoBoardBackground',
  pupCardBadge: 'pupCardBadge',
  pupCardDetailBadge: 'pupCardDetailBadge',
  powerUpCard: 'powerUpCard',
  resetTableDueFilter: 'resetTableDueFilter',
  resetTableLabelFilter: 'resetTableLabelFilter',
  resetTableListFilter: 'resetTableListFilter',
  resetTableMemberFilter: 'resetTableMemberFilter',
  savingSearchQuery: 'savingSearchQuery',
  searchMember: 'searchMember',
  searchResultCard: 'searchResultCard',
  searchSuggestion: 'searchSuggestion',
  searchTeam: 'searchTeam',
  sortTableDueAscending: 'sortTableDueAscending',
  sortTableDueDescending: 'sortTableDueDescending',
  templatePreview: 'templatePreview',
  unknown: 'unknown', // This represents a generic error case and should be used sparingly!
} as const;

export const ActionSubjectId = {
  ...inlineDialogs,
  ...modals,
  ...buttons,
  ...links,
  ...inputFields,
  ...pills,
  ...drawerNavigationItems,
  ...overlays,
  ...dropdownItems,
  ...tabs,
  ...shortcuts,
  ...menuItems,
  ...sections,
  ...sectionItems,
  ...icons,
  ...banners,
  ...atlassianAccountMigrationTerms,
  ...emailHygieneTerms,
  ...jswCrossflowItems,
  ...tiles,
  ...actions,
  ...otherActionSubjectIds,
} as const;

export type ActionSubjectIdType = typeof ActionSubjectId[keyof typeof ActionSubjectId];
